import { lazy, Suspense, useEffect, useState, type ReactNode } from "react";
import { useRouterState } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { appNavigationTab } from "@/lib/appNavigation";

const AppBottomNav = lazy(() => import("@/components/AppBottomNav").then((m) => ({ default: m.AppBottomNav })));

export function AppNavigationShell({ children }: { children: ReactNode }) {
  const location = useRouterState({ select: (state) => state.location });
  const active = appNavigationTab(location.pathname, location.hash);
  const [signedIn, setSignedIn] = useState(false);
  useEffect(() => {
    let mounted = true;
    void supabase.auth.getSession().then(({ data }) => { if (mounted) setSignedIn(!!data.session); });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => setSignedIn(!!session));
    return () => { mounted = false; subscription.unsubscribe(); };
  }, []);
  const visible = signedIn && active !== null;
  return (
    <div className={visible ? "pb-[calc(72px+env(safe-area-inset-bottom))] lg:pb-0" : undefined}>
      {children}
      {visible && <Suspense fallback={null}><AppBottomNav active={active} /></Suspense>}
    </div>
  );
}